import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DynamicIcon = _resolveComponent("DynamicIcon");
  return _renderSlot(_ctx.$slots, "icon", _normalizeProps(_guardReactiveProps(_ctx.iconProps)), () => [_createVNode(_component_DynamicIcon, {
    icon: _ctx.icon,
    iconStyle: _ctx.iconStyle,
    iconClass: _ctx.iconClassNames,
    iconAttrs: _ctx.iconAttrs
  }, null, 8, ["icon", "iconStyle", "iconClass", "iconAttrs"])]);
}